module.exports = __webpack_public_path__ + "media/images/gift/gift-og-image-28c11132112754bea2a1605c155f49f1.png";